if (!customElements.get("vp-header-component")) {
  class VPHeader extends HTMLElement {
    constructor() {
      super();
      this.hamburgerMenuButton = this.querySelector(".vp-header-section__hamburger-menu-button");
      this.hamburgerMenuClose = this.querySelector(".vp-header-section__hamburger-menu-close");
      this.headerContainer = this.querySelector("header.vp-header-section");
      this.onResize = this.updateMobileDrawerHeight.bind(this);
      this.onScroll = this.handleScrollForMobileDrawerHeight.bind(this);
      this._mobileDrawerHeightRaf = null;
      this.mobileMenuDrawerLinks = this.querySelectorAll(".vp-mobile-menu-drawer__link-container");
      this.childDrawerBackButton = this.querySelectorAll(".vp-child-drawer-back-button");
      this.childDrawerLink = this.querySelectorAll(".vp-mobile-menu-drawer__child-link-container");
      this.accordionLink = this.querySelectorAll(".vp-mobile-menu-drawer__accordion-link");
    }

    connectedCallback() {
      this.handleHamburgerMenuButtonClick();
      this.updateMobileDrawerHeight();
      this.handleChildDrawerBackButtonClick();
      this.handleChildDrawerLinkClick();
      this.handleAccordionLinkClick();
      window.addEventListener("resize", this.onResize);
      document.body.addEventListener("scroll", this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.onResize);
      document.body.removeEventListener("scroll", this.onScroll);
      if (this._mobileDrawerHeightRaf) cancelAnimationFrame(this._mobileDrawerHeightRaf);
    }

    handleScrollForMobileDrawerHeight() {
      if (this._mobileDrawerHeightRaf) return;
      this._mobileDrawerHeightRaf = requestAnimationFrame(() => {
        this._mobileDrawerHeightRaf = null;
        this.updateMobileDrawerHeight();
      });
    }

    /** Distance from viewport top to the bottom of the header's visible portion (for fixed `top`). */
    getVisibleBottom(element) {
      if (!(element instanceof HTMLElement)) return 0;
      const rect = element.getBoundingClientRect();
      if (rect.height <= 0) return 0;
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return 0;
      return Math.max(rect.bottom, 0);
    }

    getMobileHeaderTopOffset() {
      const headerGroup = document.querySelector("#header-group");
      const header = document.querySelector("header.vp-header-section");

      const candidates = [headerGroup, header].filter(Boolean);
      let offset = 0;

      candidates.forEach((el) => {
        offset = Math.max(offset, this.getVisibleBottom(el));
      });

      return offset;
    }

    handleHamburgerMenuButtonClick() {
      if (!this.hamburgerMenuButton || !this.hamburgerMenuClose) return;
      this.hamburgerMenuButton.addEventListener("click", () => {
        this.classList.toggle("drawer-open");
        this.updateMobileDrawerHeight();
      });
      this.hamburgerMenuClose.addEventListener("click", () => {
        this.classList.remove("drawer-open");

        this.mobileMenuDrawerLinks.forEach((link) => {
          link.classList.remove("active");
        });
      });
    }

    handleChildDrawerBackButtonClick() {
      if (!this.childDrawerBackButton) return;
      this.childDrawerBackButton.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          button.closest(".vp-mobile-menu-drawer__link-container")?.classList.remove("active");
        });
      });
    }

    updateMobileDrawerHeight() {
      const visibleTopOffset = this.getMobileHeaderTopOffset();
      const fallbackHeader = document.querySelector("header.vp-header-section");
      const offset =
        visibleTopOffset ||
        (fallbackHeader instanceof HTMLElement ? fallbackHeader.offsetHeight : 0) ||
        56;

      this.style.setProperty("--vp-header-mobile-height", `${offset}px`);
    }

    handleChildDrawerLinkClick() {
      if (!this.childDrawerLink) return;
      this.childDrawerLink.forEach((link) => {
        link.addEventListener("click", (e) => {
          const parentIndex = link.getAttribute("data-parent-index");

          // clear all active states before opening the selected one
          this.childDrawerLink.forEach((childLink) => {
            childLink.classList.remove("active");
          });

          let closestChildDrawerList = link.closest(".vp-mobile-menu-drawer__child-drawer").parentElement;
          closestChildDrawerList.querySelectorAll(".vp-mobile-menu-drawer__sub-child-drawer-list").forEach((list) => {
            list.classList.remove("active");
          });
          const targetSubChildDrawerList = this.querySelector(
            `.vp-mobile-menu-drawer__sub-child-drawer-list[data-parent-index="${parentIndex}"]`,
          );

          link.classList.add("active");
          targetSubChildDrawerList?.classList.add("active");
        });
      });
    }

    handleAccordionLinkClick() {
      if (!this.accordionLink) return;
      this.accordionLink.forEach((link) => {
        link.addEventListener("click", (e) => {
          link.closest(".vp-mobile-menu-drawer-accordion__child-drawer")?.classList.toggle("active");
        });
      });
    }
  }
  customElements.define("vp-header-component", VPHeader);
}
